var $77ac944da51b7354$exports = {};
const $77ac944da51b7354$var$navToggle = document.querySelector(".nav-toggle");
const $77ac944da51b7354$var$siteNav = document.querySelector(".site-nav");
if ($77ac944da51b7354$var$navToggle && $77ac944da51b7354$var$siteNav) {
    const closeMenu = ()=>{
        $77ac944da51b7354$var$navToggle.setAttribute("aria-expanded", "false");
        $77ac944da51b7354$var$siteNav.classList.remove("is-open");
    };
    $77ac944da51b7354$var$navToggle.addEventListener("click", ()=>{
        const isOpen = $77ac944da51b7354$var$navToggle.getAttribute("aria-expanded") === "true";
        $77ac944da51b7354$var$navToggle.setAttribute("aria-expanded", String(!isOpen));
        $77ac944da51b7354$var$siteNav.classList.toggle("is-open", !isOpen);
    });
    $77ac944da51b7354$var$siteNav.querySelectorAll("a").forEach((link)=>{
        link.addEventListener("click", closeMenu);
    });
    document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape") closeMenu();
    });
}
const $77ac944da51b7354$var$signupForm = document.querySelector(".signup-form");
if ($77ac944da51b7354$var$signupForm instanceof HTMLFormElement) {
    const submitButton = $77ac944da51b7354$var$signupForm.querySelector('button[type="submit"]');
    const feedback = $77ac944da51b7354$var$signupForm.querySelector(".signup-feedback");
    const successBox = document.querySelector(".signup-success");
    const successMessage = successBox?.querySelector(".signup-success-message");
    const setFeedback = (message, kind)=>{
        if (!feedback) return;
        feedback.textContent = message;
        feedback.classList.remove("is-success", "is-error");
        feedback.classList.add(kind === "error" ? "is-error" : "is-success");
        feedback.hidden = false;
    };
    const showSuccessMessage = (message)=>{
        if (!(successBox instanceof HTMLElement) || !(successMessage instanceof HTMLElement)) return;
        successMessage.textContent = message;
        successBox.hidden = false;
    };
    $77ac944da51b7354$var$signupForm.addEventListener("submit", async (event)=>{
        event.preventDefault();
        let submittedSuccessfully = false;
        if (feedback) {
            feedback.hidden = true;
            feedback.textContent = "";
            feedback.classList.remove("is-success", "is-error");
        }
        if (submitButton instanceof HTMLButtonElement) submitButton.disabled = true;
        try {
            const formData = new FormData($77ac944da51b7354$var$signupForm);
            const encodedData = new URLSearchParams(formData).toString();
            const response = await fetch("/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: encodedData
            });
            if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
            $77ac944da51b7354$var$signupForm.reset();
            $77ac944da51b7354$var$signupForm.classList.add("is-hidden");
            showSuccessMessage("Vielen Dank. Ihre Anmeldung wurde erfolgreich gesendet.");
            submittedSuccessfully = true;
        } catch (error) {
            setFeedback("Die Anmeldung konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.", "error");
            console.error(error);
        } finally{
            if (!submittedSuccessfully && submitButton instanceof HTMLButtonElement) submitButton.disabled = false;
        }
    });
}


//# sourceMappingURL=repo.34605068.js.map
